import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProductSection } from './components/ProductSection';
import { PricingSection } from './components/PricingSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FooterSection } from './components/FooterSection';
import { BuyerPopup, StickyCTA } from './components/Overlays';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-slate-50 font-sans selection:bg-emerald-200 selection:text-emerald-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <HeroSection data-id="element-2" />
      <ProductSection data-id="element-3" />
      <PricingSection data-id="element-4" />
      <SocialProofSection data-id="element-5" />
      <FooterSection data-id="element-6" />

      {/* Overlays */}
      <BuyerPopup data-id="element-7" />
      <StickyCTA data-id="element-8" />
    </div>;
}